import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import BrowserView from "@/components/BrowserView";
import { EventEmitter } from "events";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import logger from "@/utils/logger";
import _ from "lodash";
import { Loading } from "@jd/focus-desktop-comps";
import cookies from "js-cookie";
import { FocusSDK } from "@/utils";
import { legalJoyspaceUrlReg } from "@/components/Joyspace/util";
import NetworkCheck from "@/utils/NetworkCheck";
import { getNetCheckUrl } from "@/config/config";
import { getURLParameters, objectToQueryString } from "@/components/Joyspace/winOpen";
import { isLogin } from "@/utils/user";
const log = logger.getLogger("WebBrowserPage");

// const localUrl = new URL(location.href);
// let paramUrls: string[] = [];
//
// try {
//     const appParams = JSON.parse(decodeURIComponent(localUrl.searchParams.get('app_params') || ''));
//     if (Array.isArray(appParams.urls)) {
//         paramUrls = appParams.urls;
//     }
//     console.log('parse urls: ', paramUrls);
// } catch (e) {
//     console.error('failed to parse urls param: ', e);
// }

function getUrlsHost(urls: string[]): string[] {
  try {
    return _.uniq(urls.map((url) => new URL(url).origin));
  } catch (e) {
    return [];
  }
}
const notifier = new EventEmitter();

function isNoLoginRequiredUrl(url: string): boolean {
  let regexUrl = /\/download\/dns/;
  if (regexUrl.test(url)) {
    console.log("无需登录url地址", url);
    return true;
  }
  return false;
}

export default function WebBrowserPage() {
  const { focusSDK, service, onGlobalError, appRuntimeEnv } = useContext<GlobalContextConfig>(
    GlobalContext
  );
  // const cookieUrls = useRef<string[]>(getUrlsHost(paramUrls));
  // const [cookieReady, setCookieReady] = useState(false);
  // console.log(42, FocusSDK.authInfo?.ddAppId, cookies.get('focus-app-id'), appRuntimeEnv);
  const setCookies = useCallback(
    async (urls: string[]) => {
      try {
        // const { accessToken } = await service.authService.exchangeWebToken();
        for (const url of urls) {
          // 跳过无需登录的cookie设置
          if (isNoLoginRequiredUrl(url)) {
            continue;
          }
          const isJoyspaceUrl = legalJoyspaceUrlReg.test(url);
          const accessToken = (isJoyspaceUrl
            ? FocusSDK.authInfo?.accessToken || cookies.get("focus-token")
            : (await service.authService.exchangeWebToken()).accessToken) as string;
          log.debug("setBuiltInBrowserCookies", { accessToken });
          focusSDK.printLog("newWindowDebug: setBuiltInBrowserCookies", { accessToken });
          const cookiesArray = [
            {
              domain: appRuntimeEnv.domain,
              url,
              name: "focus-token",
              value: accessToken
            },
            {
              domain: appRuntimeEnv.domain,
              url,
              name: "focus-team-id",
              value: appRuntimeEnv.selectedTeamId
            },
            {
              domain: appRuntimeEnv.domain,
              url,
              name: "focus-lang",
              value: appRuntimeEnv.registryConfig.lang
            },
            {
              domain: appRuntimeEnv.domain,
              url,
              name: "focus-client",
              value: appRuntimeEnv.registryConfig.client
            },
            {
              domain: appRuntimeEnv.domain,
              url,
              name: "focus-app-id",
              value:
                FocusSDK.authInfo?.ddAppId ||
                cookies.get("focus-app-id") ||
                (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID ||
                process.env.REACT_APP_DD_APPID ||
                ""
            },
            {
              domain: appRuntimeEnv.domain,
              url,
              name: "focus-client",
              value: appRuntimeEnv.registryConfig.client
            }
          ];
          await focusSDK.setBuiltInBrowserCookies(cookiesArray);
        }
        return true;
      } catch (e) {
        onGlobalError(e);
      }
      return false;
    },
    [
      appRuntimeEnv.domain,
      appRuntimeEnv.registryConfig.lang,
      appRuntimeEnv.selectedTeamId,
      focusSDK,
      onGlobalError,
      service.authService
    ]
  );

  const addUrlNavigatorOnline = useCallback(
    async (urls) => {
      let newUrls = [];
      for (let url of urls) {
        const isJoyspaceUrl = legalJoyspaceUrlReg.test(url);
        if (isJoyspaceUrl) {
          const netServer = NetworkCheck.getInstance({
            url: getNetCheckUrl()
          });
          const navigatorOnline = await netServer.checkNet();
          const urlParameters = getURLParameters(url);
          urlParameters.navigatorOnline = String(navigatorOnline);
          let paramIndex = url.indexOf("?");
          if (paramIndex > 0) {
            url = url.substring(0, paramIndex);
          }
          url = `${url}${objectToQueryString(urlParameters)}`;
          log.debug("newWindowDebug: add navigator onLine parameter", url);
          focusSDK.printLog(`newWindowDebug: add navigator onLine parameter, ${url}`);
        }
        newUrls.push(url);
      }
      return newUrls;
    },
    [focusSDK]
  );

  const onOpenUrl = useCallback(
    async (data: string | string[]) => {
      let urls = Array.isArray(data) ? data : [data];
      isLogin() && (await setCookies(getUrlsHost(urls)));
      const newUrls = isLogin() ? await addUrlNavigatorOnline(urls) : urls;
      notifier.emit("clientMessage", {
        event: "openNewWindow",
        payload: { urls: newUrls }
      });
    },
    [setCookies, addUrlNavigatorOnline]
  );

  // const onOpenNewUrl = useCallback(
  //     async (data: any) => {
  //         if (!data.appParams) {
  //             return;
  //         }
  //         if (!data.appParams.urls) {
  //             return;
  //         }
  //         await setCookies(getUrlsHost(data.appParams.urls));
  //         notifier.emit('clientMessage', {
  //             event: 'openNewWindow',
  //             payload: { urls: data.appParams.urls },
  //         });
  //     },
  //     [setCookies]
  // );

  const onCloseWindow = useCallback(() => {
    focusSDK.closeCurrentWindow();
  }, [focusSDK]);

  const onAppParams = useCallback(
    async (params: any) => {
      if (!params || !params.urls) {
        return;
      }
      isLogin() && (await setCookies(params.urls));
      const newUrls = isLogin() ? await addUrlNavigatorOnline(params.urls) : params.urls;
      log.debug("params.urls---", newUrls);
      // console.log('this is iiiii', params.name);
      notifier.emit("clientMessage", {
        event: "openNewWindow",
        payload: { urls: newUrls, ...params.item, isNewWin: params.isNewWin }
      });
    },
    [setCookies, addUrlNavigatorOnline]
  );

  useEffect(() => {
    focusSDK.on("open-url", onOpenUrl);
    // const dispose = focusSDK.addIpcEventListener('open-url', onOpenNewUrl);
    notifier.on("closeWindow", onCloseWindow);
    const dispose1 = focusSDK.addIpcEventListener("app-params", onAppParams);
    focusSDK.removeBuiltinBrowserCookies().then(() => {
      focusSDK.ready();
    });
    return () => {
      // dispose();
      dispose1();
      focusSDK.off("open-url", onOpenUrl);
      notifier.off("closeWindow", onCloseWindow);
    };
  }, [focusSDK, onAppParams, onCloseWindow, onOpenUrl]);

  // if (!cookieReady) {
  //     return (
  //         <div className="flex1 flex-center">
  //             <Loading />
  //         </div>
  //     );
  // }

  return (
    <div
      style={{
        flex: 1,
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <BrowserView
        configData={{
          urls: [],
          partition: "persist:builtin-browser",
          allowedHosts: []
        }}
        notifier={notifier}
      />
    </div>
  );
}
